// Mock data for Masar Corner — replaced by backend API later

export const BRAND = {
  name: "مسار كورنر",
  developer: "الرمز",
  license: "رخصة وافي: 48/847",
  tagline: "متاح للبيع ضمن وجهة مسار",
};

export const NAV_LINKS = [
  { label: "لمحة عن المشروع", href: "#about" },
  { label: "المزايا والخدمات", href: "#services" },
  { label: "الوحدات المتاحة", href: "#units" },
  { label: "المعرض", href: "#gallery" },
  { label: "تواصل معنا", href: "#contact" },
];

export const HERO_STATS = [
  { value: "526", label: "وحدة سكنية" },
  { value: "2,000م", label: "عن الحرم المكي" },
  { value: "1,050م", label: "عن قطار الحرمين" },
  { value: "225م", label: "عن محطة الشاتل" },
];

export const GALLERY = [
  { src: "https://alramzre.com/wp-content/uploads/2026/05/Artboard-15%40300x-100-scaled.jpg", title: "الواجهة الرئيسية" },
  { src: "https://alramzre.com/wp-content/uploads/2026/05/Artboard-8%40300x-100-scaled.jpg", title: "إطلالة الأبراج" },
  { src: "https://alramzre.com/wp-content/uploads/2026/05/Artboard-12%40300x-100-scaled.jpg", title: "المداخل والمساحات الخارجية" },
  { src: "https://alramzre.com/wp-content/uploads/2026/05/Artboard-6%40300x-100-scaled.jpg", title: "تفاصيل الواجهات" },
  { src: "https://alramzre.com/wp-content/uploads/2026/05/Artboard-11%40300x-100-scaled.jpg", title: "زاوية عمرانية مميزة" },
];

export const HERO_IMAGE = "https://alramzre.com/wp-content/uploads/2026/05/Artboard-8%40300x-100-scaled.jpg";
export const ABOUT_IMAGE = "https://alramzre.com/wp-content/uploads/2026/05/Artboard-12%40300x-100-scaled.jpg";

// icon keys map to lucide-react icons in the component
export const SERVICES = [
  { icon: "Building2", label: "526 وحدة" },
  { icon: "Cctv", label: "كاميرات مراقبة" },
  { icon: "Warehouse", label: "مستودع" },
  { icon: "Wind", label: "مكنسة مركزية" },
  { icon: "Sun", label: "تراس وبلكونة" },
  { icon: "BedDouble", label: "غرفة خادمة" },
  { icon: "Trees", label: "مساحات خارجية" },
  { icon: "Dumbbell", label: "نادي رياضي" },
  { icon: "Moon", label: "مسجد" },
  { icon: "Leaf", label: "مسطحات خضراء" },
  { icon: "Waves", label: "مسبح" },
  { icon: "Shirt", label: "غرفة غسيل ملابس" },
  { icon: "Lightbulb", label: "إضاءة LED" },
  { icon: "DoorOpen", label: "مداخل ومخارج مكيّفة" },
  { icon: "Accessibility", label: "مواقف لأصحاب الهمم" },
];

export const UNIT_TYPES = ["غرفة وصالة", "غرفتين وصالة", "ثلاث غرف وصالة", "بنتهاوس"];
export const STATUS_OPTIONS = ["متاح", "محجوز", "مباع"];

export const MOCK_UNITS = [
  { unitNumber: "T-9-11", type: "غرفتين وصالة", area: 99, price: 3650000, floor: 9, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-9-3", type: "غرفة وصالة", area: 70, price: 2340000, floor: 9, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-9-2", type: "غرفة وصالة", area: 79, price: 2740000, floor: 9, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-9-1", type: "غرفتين وصالة", area: 93, price: 3570000, floor: 9, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-9-6", type: "غرفة وصالة", area: 83, price: 2680000, floor: 9, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-9-8", type: "غرفة وصالة", area: 68, price: 2300000, floor: 9, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-9-13", type: "غرفة وصالة", area: 74, price: 2620000, floor: 9, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-9-14", type: "غرفتين وصالة", area: 93, price: 3570000, floor: 9, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-10-6", type: "غرفة وصالة", area: 83, price: 2720000, floor: 10, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-10-9", type: "غرفة وصالة", area: 66, price: 2270000, floor: 10, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-10-2", type: "غرفة وصالة", area: 79, price: 2770000, floor: 10, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-10-4", type: "غرفة وصالة", area: 84, price: 2690000, floor: 10, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-16-9", type: "ثلاث غرف وصالة", area: 148, price: 4980000, floor: 16, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-17-9", type: "ثلاث غرف وصالة", area: 148, price: 5030000, floor: 17, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-17-4", type: "غرفتين وصالة", area: 117, price: 4140000, floor: 17, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-17-8", type: "ثلاث غرف وصالة", area: 172, price: 7710000, floor: 17, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-17-3", type: "غرفة وصالة", area: 84, price: 2960000, floor: 17, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-17-1", type: "ثلاث غرف وصالة", area: 173, price: 7380000, floor: 17, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-17-6", type: "غرفتين وصالة", area: 96, price: 3460000, floor: 17, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-33-1", type: "بنتهاوس", area: 203, price: 10910000, floor: 33, status: "متاح", tower: "البرج الطويل" },
  { unitNumber: "T-33-3", type: "بنتهاوس", area: 265, price: 16390000, floor: 33, status: "متاح", tower: "البرج الطويل" },
].map((u, i) => ({ id: `mock-${i}`, ...u }));

export const CALL_TIMES = ["صباحًا (9 - 12)", "ظهرًا (12 - 4)", "مساءً (4 - 8)", "في أي وقت"];
